import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

type Props = {
  title: string;
  children: ReactNode;
  onClose: () => void;
  actions?: ReactNode;
};

export function Modal({ title, children, onClose, actions }: Props) {
  useEffect(() => {
    const close = (event: KeyboardEvent) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <header>
          <h2 id="modal-title">{title}</h2>
          <button className="icon-button button-ghost" type="button" aria-label="Закрыть" title="Закрыть" onClick={onClose}><X /></button>
        </header>
        <div className="modal-content">{children}</div>
        {actions && <footer>{actions}</footer>}
      </section>
    </div>
  );
}

